import Loading from 'components/Loading'
import useAuth from './hooks/useAuth'
import React from 'react'

const Apple: React.FC = () => {
  useAuth('apple')
  return (
    <Loading />
  )
}

export default Apple